import { render, staticRenderFns } from "./DeliveryIssues.vue?vue&type=template&id=f5e8108c&scoped=true&"
import script from "./DeliveryIssues.vue?vue&type=script&lang=js&"
export * from "./DeliveryIssues.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryIssues.vue?vue&type=style&index=0&id=f5e8108c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e8108c",
  null
  
)

export default component.exports